var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhiteCrossRedBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.45312,
    r: 6,
    fill: "#E7514F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.45706L7.99643 3.95349L6 5.94992L4.00357 3.95349L3.5 4.45706L5.49643 6.45349L3.5 8.44992L4.00357 8.95349L6 6.95706L7.99643 8.95349L8.5 8.44992L6.50357 6.45349L8.5 4.45706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhiteCrossRedBackground);
export default __webpack_public_path__ + "static/media/icon_white-cross-red-background.ac1185c0064d26a1d44498d5284a21d2.svg";
export { ForwardRef as ReactComponent };